// client/safe-popup.ts
async function openPopupWithLoadingScreen(urlPromise, { loadingText, spinnerColor, closeAfterResolve = false } = {}) {
  if (spinnerColor && !spinnerColor.startsWith("#"))
    throw new Error("openPopupWithLoadingScreen: only hex colors can be used as spinnerColors");
  let url = "/__print/__loading";
  if (loadingText || spinnerColor) {
    const params = new URLSearchParams();
    if (loadingText)
      params.set("text", loadingText);
    if (spinnerColor)
      params.set("color", spinnerColor.slice(1));
    url += "?" + params.toString();
  }
  const page = window.open(url, "_blank");
  try {
    const target = await urlPromise;
    if (page)
      page.location = target;
    if (closeAfterResolve)
      setTimeout(() => page?.close(), 100);
  } catch (error) {
    page?.close();
    throw error;
  }
}
export {
  openPopupWithLoadingScreen
};
